import React from 'react';
import Card from './Card';
import './CardList.css'
const CardList = ({ schedule,  onclick}) => {


  return (
    <div  className='tc br3 dib shadow-5 bg-white app-width'> 
    
      {
        schedule.map((app, i) => {
          return (
            <Card
              key={i}
              id={schedule[i].id}
              time={schedule[i].time}
              type={schedule[i].type}
              customer={schedule[i].customer}
              phone={schedule[i].phone}
              description={schedule[i].description}
              clickHandler={onclick}
              done={schedule[i].done ? schedule[i].done : false}
            />
          );
        })
      }
    </div>
  );
}

export default CardList;